import axios from 'axios';

export type CreateOffer = {
  productId: number;
  companyId: number;
  prices: { price: number; amount: number }[];
  stockQuantity: number;
  orderQuantity: number;
  deliveryPeriod: number;
  quantityLevel?: 'little' | 'medium' | 'much';
  secondQuantityLevel?: 'little' | 'medium' | 'much';
};

export function createOffer(data: CreateOffer) {
  return axios.post('/api/shop/offer', data);
}

export function importOffers({ file, company_id }: { file: FormData; company_id?: number }) {
  return axios.post('/api/shop/import_offers', file, {
    params: {
      company_id,
    },
  });
}

export function importNewProducts({ file }: { file: FormData }) {
  return axios.post('/api/shop/import_new_products', file);
}

export function importProductData({ file }: { file: FormData }) {
  return axios.post('/api/shop/import_products', file);
}

export function getOffers({
  company_id,
  product_id,
  status,
  new_status,
  page,
  per_page,
}: {
  company_id?: number;
  product_id?: number;
  status?: 'moderation' | 'active' | 'deleted';
  new_status?: 'moderation' | 'active' | 'deleted';
  page?: number;
  per_page?: number;
}) {
  return axios.post(
    '/api/shop/offers',
    {},
    { params: { status, new_status, company_id, product_id, page, per_page } }
  );
}

export function deleteOffer(id: number) {
  return axios.delete(`/api/shop/offer/${id}`);
}

export function editOffersStatus({
  ids,
  status,
}: {
  ids: string;
  status: 'moderation' | 'active' | 'deleted';
}) {
  return axios.put(`/api/shop/offers_status`, {}, { params: { ids, status } });
}

export function getOffersCompanies({
  status,
}: {
  status?: 'moderation' | 'active' | 'deleted';
}) {
  return axios.get('/api/shop/offers_companies', { params: { status } });
}

export function getImportOffersFiles({
  page,
  per_page,
  errors,
}: {
  page?: number;
  per_page?: number;
  errors?: boolean;
}) {
  return axios.get('/api/shop/import_offers/files', {
    params: {
      page,
      per_page,
      errors,
    },
  });
}

export function getOfferErrors({
  id,
  page,
  per_page,
}: {
  id: number;
  page?: number;
  per_page?: number;
}) {
  return axios.get(`/api/shop/import_offer_errors/${id}`, {
    params: {
      page: 1,
      per_page: 2000,
    },
  });
}

export function deleteOfferImport({ id }: { id: number }) {
  return axios.delete(`/api/shop/import_offer/${id}`);
}
